// @ts-strict-ignore
import type { ActionContext } from 'vuex'
import type { ActionClass, ContextState, Dictionary, FilterSelectedValues } from '../../../models'
import { FilterIdEnum } from '../../../enums'
import { CONTEXT_CONSTS } from '../../../store/context/context.consts'
import { mapToolStateToContext } from '../utils/map-tool-state-to-context'

export class SetFiltersSelectedValuesAction implements ActionClass {
  static execute(
    this: void,
    { state, commit, dispatch }: ActionContext<ContextState, any>,
    selectedFiltersValues: Dictionary<FilterSelectedValues>,
  ): void {
    if (selectedFiltersValues[FilterIdEnum.ENDPOINT]) {
      const endpointId = selectedFiltersValues[FilterIdEnum.ENDPOINT][0]
      dispatch(CONTEXT_CONSTS.actions.setEndpointId, endpointId)
    }

    const context: Partial<ContextState> = state.currentFeature
      ? mapToolStateToContext(state, { selectedFiltersValues })
      : { filters: mapContextFilters(state.filters, selectedFiltersValues) }

    commit(CONTEXT_CONSTS.mutations.setContext, context)
  }
}

function mapContextFilters(
  filters: ContextState['filters'],
  selectedFiltersValues: Dictionary<FilterSelectedValues>,
): ContextState['filters'] {
  if (!selectedFiltersValues) return

  const updatedFilters: ContextState['filters'] = structuredClone(filters)

  for (const key in selectedFiltersValues) {
    const filter = filters[key]

    filter.selectedValues = selectedFiltersValues[key]

    updatedFilters[filter.config.id] = filter
  }

  return updatedFilters
}
